import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/404.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-46807119"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "game-panel" };
var _hoisted_2 = { class: "game-panel-inner" };
var _hoisted_3 = { class: "leaderboard" };
var _hoisted_4 = {
    class: "content-wrap",
    style: { "overflow": "visible" }
};
var _hoisted_5 = { class: "content" };
var _hoisted_6 = { class: "col-12 col-md-12 col-xs-12" };
var _hoisted_7 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "top-divider" }, null, -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("img", {
                                src: _imports_0,
                                class: "not-found-img",
                                onClick: _cache[0] || (_cache[0] = function ($event) { return ($data.store.commit('goTo', '/')); })
                            })
                        ])
                    ])
                ]),
                _hoisted_7
            ])
        ])
    ]));
}
